import React from 'react';
import { Loader2, Send } from 'lucide-react';

/**
 * Composer at the bottom of the chat panel. Submits on Enter (shift-enter
 * for newlines is preserved because we swallow only plain Enter).
 */
const CopilotInput = React.forwardRef(function CopilotInput(
  { value, onChange, onSend, isLoading },
  ref,
) {
  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };
  const sendDisabled = !value.trim() || isLoading;

  return (
    <div className="p-4 border-t border-slate-700 bg-slate-800/50 rounded-b-2xl">
      <div className="flex items-center gap-2">
        <input
          ref={ref}
          data-testid="copilot-input"
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKey}
          placeholder="Ask anything about Baselinx..."
          className="flex-1 bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition text-sm"
          disabled={isLoading}
        />
        <button
          data-testid="copilot-send-btn"
          onClick={onSend}
          disabled={sendDisabled}
          className={`p-3 rounded-xl transition ${
            !sendDisabled
              ? 'bg-gradient-to-r from-cyan-500 to-purple-600 text-white hover:shadow-lg hover:shadow-cyan-500/25'
              : 'bg-slate-700 text-gray-500 cursor-not-allowed'
          }`}
        >
          {isLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
        </button>
      </div>
      <p className="text-gray-500 text-xs mt-2 text-center">
        Powered by GPT-4o • Read-only assistant
      </p>
    </div>
  );
});

export default CopilotInput;
